/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Upgrade_Plan_Modal_Plans_Personal_DescriptionInputs */

const es_components_upgrade_plan_modal_plans_personal_description = /** @type {(inputs: Components_Upgrade_Plan_Modal_Plans_Personal_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ideal para profesionales independientes y equipos pequeños.`)
};

const en_components_upgrade_plan_modal_plans_personal_description = /** @type {(inputs: Components_Upgrade_Plan_Modal_Plans_Personal_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Great for individual professionals and small teams.`)
};

/**
* | output |
* | --- |
* | "Great for individual professionals and small teams." |
*
* @param {Components_Upgrade_Plan_Modal_Plans_Personal_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_upgrade_plan_modal_plans_personal_description = /** @type {((inputs?: Components_Upgrade_Plan_Modal_Plans_Personal_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Upgrade_Plan_Modal_Plans_Personal_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_upgrade_plan_modal_plans_personal_description(inputs)
	return en_components_upgrade_plan_modal_plans_personal_description(inputs)
});
export { components_upgrade_plan_modal_plans_personal_description as "components.upgrade_plan_modal.plans.personal.description" }